// extracted by mini-css-extract-plugin
export default {"user":"Jt6iyJ","userCentered":"ouKSVQ"};